export default __webpack_public_path__ + "static/media/info_image.ed164de0.jpg";